import React from 'react';
import { genericAtom } from './jotai';

export interface PrintTemplateState {
    view?: React.ReactNode;
}

export const currentPrintTemplateState = genericAtom<PrintTemplateState | null>(null);

